module.exports = __webpack_public_path__ + "images/marketing/table-laptop-coffee.jpg";